import { createSelector } from 'reselect'
import { PROGRESS_STATES } from 'constants/enums'

const awardStates = states => states

const filterStates = states => {
  return states.filter(
    item => item.value !== PROGRESS_STATES.awardRegNotApproved.id
  )
}

export default createSelector(awardStates, filterStates)
